// extracted by mini-css-extract-plugin
module.exports = {"root":"mlN6p","full":"xdfc9","bottom":"arKbb"};